import { faTable } from "@fortawesome/free-solid-svg-icons";
import React, { useEffect, useState } from "react";
import LineEditable from "./LineEditable";
import { Button } from "react-bootstrap";
import Alert from "../alert/Alert";
import "./tableEditable.css";

const TableEditable = (props)=>{

    const [lines, setLines] = useState([]);
    const [itemSelected, setItemSelected] = useState(null);
    const [data, setData] = useState([]);

    const [message, setMessage] = useState("");
    const [show, setShow] = useState(false);
    
    useEffect(()=>{
        if(props.data.length > 0){
            setData(props.data)
        }
    }, [props.data])

    return(<>
        {show == true ? (<Alert
                show={show}
                message={message}
                parentCallback={()=>setShow(false)}>

                    </Alert>) : (null)}
        <table className="table-editable">
            <tr>
                <th>Código</th>
                <th>Alternativa</th>
                <th>PPH</th>
                <th>N° Peça/Ciclo</th>
                <th>Tempo de espera</th>
                <th>Máquina</th>
                <th>Ação</th>
            </tr>
            {data.length > 0 ? (
                <>
                
                {
                  data.map((element)=>
                    <LineEditable setShow={setShow} setMessage={setMessage} arrLength={props.data.length} operation={element} del={props.del} alt={props.alt}></LineEditable>
                  )  
                }
                </>
            ) : ("Nenhum dado para ser exibido.")}
        </table>
    </>);
}

export default TableEditable;